import React from 'react';
import {
  GetSignedUrlS3,
  UploadSignedUrlToS3
} from 'services/rest/UploadImage/UploadImgToS3';

export async function awsUploadFileHelper(
  currentUser: string,
  file: any,
  folder: string,
  name: string,
  isCrop: boolean,
  setError?: any,
  message?: string,
  subdomain?: string
): Promise<string | undefined> {
  try {
    const result = await GetSignedUrlS3(currentUser, name, folder, subdomain);
    const payload = result.data.data;
    const isObject = payload && typeof payload === 'object';
    const signedUrl = isObject ? payload.signedUrl : payload;
    const key = isObject ? payload.key : undefined;

    await UploadSignedUrlToS3(
      signedUrl,
      isCrop ? file : file['file'],
      isCrop ? 'image/png' : file['file']['type']
    );
    return key;
  } catch (error) {
    setError && setError(message);
    return undefined;
  }
}

export function setFileNameHelper(file: any, isEditMultiple: boolean) {
  let fileName = '';
  if (isEditMultiple) {
    if (file?.name.length > 0) {
      const getType = file['file']['type'].split('/');
      fileName = `${file['index']}.${getType[1]}`;
    } else {
      const getName = file.url.split('/');
      fileName = getName[5];
    }
  } else {
    if (file.name) {
      const getType = file['file']['type'].split('/');
      fileName = `${file['index']}.${getType[1]}`;
    }
  }
  return fileName;
}
